import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function UnitsCtrl (
  $rootScope,
  $scope,
  $state,
  $translate,
  dateParsing,
  tableApi,
  workshopAPI,
  sessionObjAPI,
  bodyTypes,
  franchises,
  transmissionTypes,
  units
) {

  $scope.bodyTypes         = bodyTypes;
  $scope.company           = sessionObjAPI.company();
  $scope.currency          = sessionObjAPI.currency();
  $scope.franchises        = franchises;
  $scope.tableCacheKey     = 'units';
  $scope.transmissionTypes = transmissionTypes;
  $scope.units             = units;
  $scope.years             = dateParsing.priorYears();

  $scope.conditions = [
    {
      code       : 'all',
      description: $translate.instant('GENERAL_SPACE.BUTTON.ALL')
    },
    {
      code       : 'new',
      description: $translate.instant('DEALERSHIP_SPACE.NEW')
    },
    {
      code       : 'used',
      description: $translate.instant('DEALERSHIP_SPACE.USED')
    }
  ];

  $scope.statuses = [
    {
      code       : 'all',
      description: 'All'
    },
    {
      code       : 'for_sale',
      description: 'For Sale'
    },
    {
      code       : 'sold',
      description: 'Sold'
    }
  ];

  $scope.sortOptions = [
    {
      code       : '',
      description: $translate.instant('DEALERSHIP_SPACE.DEFAULT')
    },
    {
      code       : 'year',
      description: $translate.instant('VEHICLE_SPACE.YEAR')
    },
    {
      code       : 'mileage',
      description: $translate.instant('DEALERSHIP_SPACE.MILEAGE')
    },
    {
      code       : 'price',
      description: $translate.instant('JS_SPACE.COLUMNS.PRICE')
    }
  ];

  $scope.filtering = tableApi.setFiltersFromCache($scope.tableCacheKey, {
    bodyType        : '',
    condition       : '',
    franchise       : '',
    make            : '',
    maxMileage      : '',
    maxPrice        : '',
    minPrice        : '',
    model           : '',
    newestYear      : '',
    oldestYear      : '',
    order           : '',
    sale_status     : 'for_sale',
    stock_number    : '',
    transmissionType: ''
  });

  $scope.tableSettings = {
    broadcast: 'filterUnits',
    cache    : {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'stock_number',
        header: {
          text: $translate.instant('DEALERSHIP_SPACE.STOCK_NUMBER')
        }
      },
      {
        field : 'is_new',
        header: {
          text: $translate.instant('DEALERSHIP_SPACE.CONDITION')
        },
        pipe: 'unitCondition'
      },
      {
        field : 'days_in_stock',
        header: {
          text: $translate.instant('DEALERSHIP_SPACE.DAYS_IN_STOCK')
        }
      },
      {
        field : 'make',
        header: {
          text: $translate.instant('VEHICLE_SPACE.MAKE')
        }
      },
      {
        field : 'model',
        header: {
          text: $translate.instant('VEHICLE_SPACE.MODEL')
        }
      },
      {
        field : 'body_type',
        header: {
          text: $translate.instant('VEHICLE_SPACE.BODY_TYPE')
        }
      },
      {
        field : 'transmission',
        header: {
          text: $translate.instant('VEHICLE_SPACE.TRANSMISSION')
        }
      },
      {
        field : 'build_date',
        header: {
          text: $translate.instant('VEHICLE_SPACE.BUILD_DATE')
        }
      },
      {
        field : 'odometer',
        header: {
          text: $translate.instant('VEHICLE_SPACE.ODOMETER')
        }
      },
      {
        field : 'group_or_franchise_name',
        header: {
          text: $translate.instant('COMPANY_SPACE.FRANCHISE.GROUP_FRANCHISE')
        }
      },
      {
        field : $scope.company.price_includes_tax ? 'suggested_sale_price_including_tax' : 'suggested_sale_price',
        header: {
          text: $translate.instant('DEALERSHIP_SPACE.SUGGESTED_SALE_PRICE')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewUnit(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_UNITS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 10,
      pageSizes : [ 10, 25, 50 ],
      queryCount: () => workshopAPI.post('/vehicles/for_sale_count', {}),
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getUnits = ( params ) => {
    return workshopAPI.post('/vehicles/for_sale_index', {
      body_type         : $scope.filtering.bodyType,
      group_or_franchise: $scope.filtering.franchise,
      make              : $scope.filtering.make,
      max_mileage       : $scope.filtering.maxMileage,
      model             : $scope.filtering.model,
      newest_year       : $scope.filtering.newestYear,
      offset            : params.offset,
      oldest_year       : $scope.filtering.oldestYear,
      order_by          : $scope.filtering.order,
      page_size         : params.pageSize,
      price_max         : $scope.filtering.maxPrice,
      price_min         : $scope.filtering.minPrice,
      sale_status       : $scope.filtering.sale_status,
      stock_number      : $scope.filtering.stock_number,
      transmission      : $scope.filtering.transmissionType,
      used_or_new       : $scope.filtering.condition
    })
    .then(units => {
      $scope.units = units;

      return units;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewUnit(event.row);
  };

  $scope.viewUnit = function (unit) {
    $state.go('app.unit', {
      id: unit.id
    });
  };

  $scope.clearFilter = function (input) {
    $scope.filtering[input] = '';
  };

  $scope.clearFilters = function () {
    angular.forEach($scope.filtering, function (value, key) {
      $scope.filtering[key] = '';
    });

    $scope.filtering.sale_status = 'for_sale';
  };

  $scope.refresh = function() {
    $state.reload();
  };

  $scope.$watch('[filtering.bodyType, filtering.condition, filtering.franchise, filtering.make, filtering.maxMileage, filtering.maxPrice, filtering.minPrice, filtering.model, filtering.newestYear, filtering.oldestYear, filtering.order, filtering.stock_number, filtering.transmissionType, filtering.sale_status]', function (newVal, oldVal) {
    if (newVal !== oldVal) {
      window['filterUnits']($scope.filtering);
    }
  }, true);
}